import { useCallback, useContext, useMemo, useState } from "react";
import debounce from "lodash-es/debounce";
import { useMemoizedFn } from "ahooks";
import log from "logbeacon";
import { type OpenDataToken, OspApiClientContext } from "@features";

/**
 * @deprecated please use `useOpenDataSearch` instead
 * @returns
 */
export const useSearchToken = () => {
  const [data, setData] = useState<OpenDataToken[]>();
  const { openApi } = useContext(OspApiClientContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  const searchToken = useCallback(
    async (keyword: string) => {
      if (!keyword) {
        setData(undefined);
        return;
      }
      setIsLoading(true);
      try {
        const response = await openApi?.tokenseek.searchToken({
          keyword,
          page: 0,
          limit: 100,
        });

        if (response?.data?.data) {
          // 根据实际API返回数据结构进行转换
          const formattedData = response.data.data.rows;
          log.debug("[文案]formattedData", formattedData);
          setData(formattedData);
        }
        setIsSearch(true);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        log.error("[文案]Search token error:", error);
        setData(undefined);
      }
    },

    [openApi],
  );

  const debounceSearch = useMemoizedFn((keyword: string) => {
    searchToken(keyword);
  });

  // 使用debounce处理搜索，300ms延迟
  const onSearch = useMemo(() => {
    return debounce(debounceSearch, 300);
  }, []);

  return {
    data: (data || []).map((row: any) => {
      // 接口说直接取第0个
      const tokenPool = row.pools?.[0] || row;
      log.debug("[文案]tokenPool", row, tokenPool);
      return {
        ...row,
        poolAddress: tokenPool?.pool_address || row.address,
        trade: tokenPool?.trade,
        key: `${row.name}-${row.token_created_at}`,
      };
    }),
    onSearch,
    isLoading,
    setIsSearch,
    isSearch,
  };
};
